// Language folder of the Raben help PDFs under https://assets.envirly.pl/raben/.
// Romanian has no files there (403, checked 2026-11-03), so it uses English.
const ASSET_FALLBACK: Record<string, string> = { ro: 'en' };

export const assetLanguage = (language: string): string =>
  ASSET_FALLBACK[language] ?? language;
